import * as React from "react"
import {Box} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";


export default function positionColumn() {
	return {
		name: 'position', label: 'Position',
		options: {
			filterType: "textField",
			customBodyRowRender: value => <Box sx={{ textAlign: 'center' }}>
				<Box component="span">{value} <IconSeeker icon="up-down" sx={{ fontSize: 10 }} /></Box>
			</Box>
		}
	}
}